import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { sessionDestroy } from '../slices/sessionSlice';
import auth from '../utils/auth';

const Logout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    React.useEffect(() => {
        (() => {
            auth.logout();
            dispatch(sessionDestroy());
            navigate('/login');
        })();
    }, [dispatch, navigate]);

    return <p>You have been logged out, you will be redirected shortly to login...</p>;
};
export default Logout;
